// @flow

import React from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import IconButton from '../../../../components/IconButton';
import VisioGlobeUI from '../../../common/VisioGlobeUI';
import type { MapViewer } from '../../../../types/VisioglobeType';
import type { ShoppingCenterGemini, VisioglobeUnitsOk } from '../../../../types/geminiType';
import Legend from './Legend';
import RippleButton from '../../../../components/RippleButton';
import QuantilsLegend from './QuantilsLegend';
import { visioGlobeEmptyUnitColor } from '../../../../const';

type Props = {
  hideAllViews: Function,
  allHidden: boolean,
  mapviewer: MapViewer,
  shoppingCenterData: ShoppingCenterGemini,
  storeCategory: string,
  visioglobeUnits: VisioglobeUnitsOk[],
  currentKpiFilter: string,
  isCurrencyBySurface: boolean,
  changeMappingMode: Function,
  isMappingUser: boolean,
  displayBusinessPlan: Function,
  isBusinessPlanModuleDisplayed: boolean,
  isQuartilsLegendHidden: boolean,
  displayEmptyUnits: Function,
  isDisplayEmptyUnits: boolean,
}

type State = {
  legendHidden: boolean,
}

class GeminiLegend extends React.Component<Props, State> {
  state: State = {
    legendHidden: true,
  };

  toggleLegend = (force: boolean) => {
    this.setState({ legendHidden: force && !this.state.legendHidden });
  };

  getLegend = () => {
    if (this.props.isBusinessPlanModuleDisplayed) {
      return <Legend />;
    }
    if (this.props.isDisplayEmptyUnits) {
      return (
        <div className="legend-container">
          <div className="legend-item business-plan">
            <div className="color-item" style={{ backgroundColor: visioGlobeEmptyUnitColor }} />
            <Translate value="GEMINI.EMPTY_UNITS" />
          </div>
        </div>
      );
    }
  };

  render() {
    return (
      <div className="bottom-menu-gemini-container">
        <div className="bottom-menu-container">
          <div className="bottom-menu-gemini">
            <div className="bottom-menu-settings">
              <IconButton
                icon={`${!this.props.allHidden ? 'fas fa-expand-alt' : 'fas fa-compress-alt'}`}
                className="expand-button"
                onClick={this.props.hideAllViews}
              />
              <div className="bottom-menu-legend-container">
                {
                  !this.state.legendHidden && this.getLegend()
                }
                {
                  this.props.isBusinessPlanModuleDisplayed
                  && (
                    <IconButton
                      icon={`${!this.state.legendHidden ? 'fas fa-times' : 'fas fa-info'}`}
                      className="expand-button"
                      onClick={() => this.toggleLegend(true)}
                    />
                  )
                }
                <RippleButton
                  className={`text-button rounded-button expand-button ${this.props.isDisplayEmptyUnits ? 'selected' : ''}`}
                  onClick={() => {
                    this.props.displayEmptyUnits();
                    this.toggleLegend(false);
                  }}
                  title={I18n.t(`GEMINI.${this.props.isDisplayEmptyUnits ? 'HIDE' : 'SHOW'}_EMPTY_UNITS`)}
                ><Translate value="GEMINI.EMPTY_UNITS" />
                </RippleButton>
                <RippleButton
                  className={`rounded-button expand-button ${this.props.isBusinessPlanModuleDisplayed ? 'selected' : ''}`}
                  onClick={() => {
                    this.props.displayBusinessPlan();
                    this.toggleLegend(false);
                  }}
                >BP
                </RippleButton>
                {
                  this.props.isMappingUser
                  && (
                    <RippleButton
                      className="text-button rounded-button expand-button"
                      onClick={this.props.changeMappingMode}
                    ><Translate value="GEMINI.MAPPING_MODE" />
                    </RippleButton>
                  )
                }
              </div>
            </div>
            {
              this.props.shoppingCenterData
              && !this.props.isQuartilsLegendHidden
              && (
                <QuantilsLegend
                  visioglobeUnits={this.props.visioglobeUnits}
                  currentKpiFilter={this.props.currentKpiFilter}
                  storeCategory={this.props.storeCategory}
                  shoppingCenterData={this.props.shoppingCenterData}
                  isCurrencyBySurface={this.props.isCurrencyBySurface}
                />
              )
            }
          </div>
          <VisioGlobeUI mapviewer={this.props.mapviewer} />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  isCurrencyBySurface: state.store.isCurrencyBySurface,
}))(GeminiLegend);
